import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { getter } from '@progress/kendo-react-common';
import { useEffect, useState } from 'react';
import PositionTable from './positions';
import ResourceTable from './resources';
import TimesheetTable from './timesheets';
import CRapplyPositionTable from './CRTables/CRapplypositions';

const DATA_ITEM_KEY: string = 'candidateId';
const SELECTED_FIELD: string = 'selected';
const idGetter = getter(DATA_ITEM_KEY);

const SelectedTables = (props: any) => {
     
  let products: {candidateId: string, allocatedTo: string}[] = props.data

  const [dataState, setDataState] = useState(  products && products.map((dataItem: any) =>
    Object.assign({ selected: false }, dataItem._source)    
  ));

  
  const [selectedState, setSelectedState] = useState<{
    [id: string]: boolean | number[];
  }>({});
  
  const [selectedCandidates, setSelectedCandidates] = useState<{name: string, candidateId: string, company: string}[]>([]);

  useEffect(() => {
    setDataState(products && products.map((dataItem: any) =>
      Object.assign({ selected: false }, dataItem._source) 
    ))
  }, [products])

  return (
    <div className="tableStyle">
        { props && props.type === 'positions' && <PositionTable dataState={dataState} selectedState={selectedState} state={props.state} data={props.data} total={props.total}  pageChange={props.pageChange}  pageSize={props.pageSize} onSelection={props.onSelection} onRowClick={props.onRowClick}/>  }
        { props && props.type === 'resources' && <ResourceTable dataState={dataState} selectedState={selectedState} state={props.state} data={props.data} total={props.total}  pageChange={props.pageChange}  pageSize={props.pageSize} onSelection={props.onSelection} onRowClick={props.onRowClick}/>  }
        { props && props.type === 'timesheets' && <TimesheetTable dataState={dataState} selectedState={selectedState} state={props.state} data={props.data} total={props.total}  pageChange={props.pageChange}  pageSize={props.pageSize} onSelection={props.onSelection} onRowClick={props.onRowClick} sendReminder={props.sendReminder} showHistory={props.showHistory}/>  }
        { props && props.type === 'CRapplyPositionTable' && < CRapplyPositionTable dataState={dataState} selectedState={selectedState} state={props.state} data={props.data} total={props.total}  pageChange={props.pageChange}  pageSize={props.pageSize} onSelection={props.onSelection} onRowClick={props.onRowClick}/>  }
    </div>
  );
};
export default SelectedTables;


